import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import type { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ArrowRightIcon, StarSparklesIcon } from '@tyro/icons';
import { useIsTyroneUser } from '../../../hooks/use-is-tyrone-user';
import { TyroneEvent } from '../header/tyrone-popover/events';

function openTyrone() {
  window.dispatchEvent(new CustomEvent(TyroneEvent.open));
}

const gradientButtonSx = {
  color: 'common.white',
  background: (theme: Theme) =>
    `linear-gradient(135deg, ${theme.palette.indigo[500]}, ${theme.palette.violet[500]})`,
  transition: (theme: Theme) =>
    theme.transitions.create(['filter', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
  '&:hover': {
    filter: 'brightness(1.06)',
  },
};

export function TyroneNavButton() {
  const showTyrone = useIsTyroneUser();
  if (!showTyrone) return null;

  return (
    <Stack sx={{ px: 2, pt: 1.5 }}>
      <ButtonBase
        onClick={openTyrone}
        aria-label="Have a question? Open Tyrone"
        sx={{
          ...gradientButtonSx,
          width: 1,
          borderRadius: 1.5,
          px: 1.5,
          py: 1.25,
          '&:hover .TyroneNavButton-arrow': {
            transform: 'translateX(3px)',
          },
          '&:active': {
            transform: 'scale(0.98)',
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ width: 1 }}
        >
          <StarSparklesIcon sx={{ width: 20, height: 20, flexShrink: 0 }} />
          <Typography
            component="span"
            variant="subtitle2"
            sx={{ flex: 1, textAlign: 'left' }}
          >
            Have a question?
          </Typography>
          <ArrowRightIcon
            className="TyroneNavButton-arrow"
            sx={{
              width: 18,
              height: 18,
              flexShrink: 0,
              transition: (theme) =>
                theme.transitions.create('transform', {
                  duration: theme.transitions.duration.shorter,
                }),
            }}
          />
        </Stack>
      </ButtonBase>
    </Stack>
  );
}

export function TyroneNavMiniButton() {
  const showTyrone = useIsTyroneUser();
  if (!showTyrone) return null;

  return (
    <Stack alignItems="center" sx={{ mb: 1 }}>
      <Tooltip title="Have a question?" placement="right">
        <ButtonBase
          onClick={openTyrone}
          aria-label="Have a question? Open Tyrone"
          sx={{
            ...gradientButtonSx,
            width: 40,
            height: 40,
            borderRadius: '50%',
            '&:active': {
              transform: 'scale(0.94)',
            },
          }}
        >
          <StarSparklesIcon sx={{ width: 20, height: 20 }} />
        </ButtonBase>
      </Tooltip>
    </Stack>
  );
}
